import React from "react"
import { connect } from "react-redux"
import { Box } from "@infotech/uikit-grid"
import {
  useEntityApi,
  useEntityApiList,
} from "src/engine/modules/api/hooks/getEntityApi"
import { useEntityActions } from "src/engine/modules/api/hooks/useEntityActions"

import {
  selectApiEntity,
  selectApiEntityList,
} from "src/engine/modules/api/selectors"
import {
  requestApiEntity,
  requestApiEntityList,
} from "src/engine/modules/api/actions/creators"
import { useNow } from "src/hooks"
import {
  EVENT_TYPE_CREATE,
  EVENT_TYPE_UPDATE,
  EVENT_TYPE_DELETE,
} from "src/constants/knownPermissions"
import { SUPER_ADMIN } from "src/constants/knownRoles"
import { EVENT_TYPES_URL } from "src/constants/routeNames"
import { hasPermission, hasRole } from "src/engine/modules/currentUser"

import Modal from "./Modal"

const EventType = ({
  eventType,
  resourceTypeList,
  match: {
    params: { id },
  },
  history,
  requestApiEntity,
  requestApiEntityList,
  disableCreate,
  disableEdit,
  disableDelete,
  statusModelPermission,
}) => {
  const isNew = id === `new`
  const backToList = () => history.push(EVENT_TYPES_URL)
  const [refreshTimestamp, refreshEntity] = useNow()
  useEntityApi({
    name: `eventType`,
    urlName: `/events/types`,
    key: id,
    hold: isNew,
    refresh: refreshTimestamp,
    requestApiEntity,
  })
  useEntityApiList({
    name: `resourceType`,
    urlName: `/resources/types`,
    key: id,
    refresh: refreshTimestamp,
    requestApiEntityList,
  })
  const { actionStatus: createStatus, entityAction: create } = useEntityActions(
    {
      name: `eventType`,
      urlName: `/events/types`,
      actionMethod: `create`,
      withRedirect: {
        history,
        redirectUrl: `/event-types/`,
      },
    },
  )
  const { actionStatus: updateStatus, entityAction: update } = useEntityActions(
    {
      name: `eventType`,
      urlName: `/events/types`,
      key: id,
      actionMethod: `update`,
    },
  )
  return (
    <Box loose>
      <Modal
        isNew={isNew}
        refreshEntity={refreshEntity}
        eventType={eventType}
        resourceTypeList={resourceTypeList}
        id={id}
        backToList={backToList}
        create={create}
        actionStatus={isNew ? createStatus : updateStatus}
        update={update}
        disableCreate={disableCreate}
        disableEdit={disableEdit}
        disableDelete={disableDelete}
        statusModelPermission={statusModelPermission}
      />
    </Box>
  )
}

export default connect(
  state => ({
    eventType: selectApiEntity(state, `eventType`),
    resourceTypeList: selectApiEntityList(state, `resourceType`),
    disableCreate: !hasPermission(EVENT_TYPE_CREATE)(state),
    disableEdit: !hasPermission(EVENT_TYPE_UPDATE)(state),
    disableDelete: !hasPermission(EVENT_TYPE_DELETE)(state),
    statusModelPermission: hasRole(SUPER_ADMIN)(state),
  }),
  {
    requestApiEntity,
    requestApiEntityList,
  },
)(EventType)
